import { isNil } from '@/utils/isNil';
import clsx from 'clsx';
import { FC, ReactNode } from 'react';

interface Props {
  title?: ReactNode;
  subtitle?: ReactNode;
  description?: ReactNode;
  className?: string;
}

export const AuthFormHeader: FC<Props> = ({ title, subtitle, description, className }) => {
  return (
    <section className={clsx('mb-8 sm:grid sm:place-items-center', className)}>
      <header className="px-10 sm:px-0 sm:text-center">
        {!isNil(title) && <h1 className="c-fs-h5 m-0 font-extrabold text-tex-def-tie1 sm:max-w-sm">{title}</h1>}
        {!isNil(subtitle) && (
          <div className="c-fs-body1 flex flex-col gap-2 text-tex-def-tie2 sm:max-w-sm">{subtitle}</div>
        )}
      </header>
      {!isNil(description) && (
        <div className="c-fs-body1 mt-4 flex flex-col gap-2 text-tex-def-tie1 sm:max-w-sm sm:text-center">
          {description}
        </div>
      )}
    </section>
  );
};
